<template>
    <v-chip :color="getColor(value)" :class="[isDark ? 'dark-chip-col' : '']">
    {{ translatedDisplayValue }}
    </v-chip>
</template>

<script>
import _ from 'lodash'

  export default {
    name: 'SeverityChip',
    props: {
      value: {type: String, default: 'low'}
    },
      computed:{
          isDark(){
              return this.unifiedIsThemeDark
          },
          displayValue(){
            return _.upperFirst(this.value.toLowerCase())
          },
            translatedDisplayValue(){
              const translatedValue = this.$options.filters.translate(this.displayValue)
              return translatedValue === this.displayValue ? this.value : translatedValue
            },
      },
    data () {
      return {
        severityColors: {
          'critical': 'red',
          'medium': 'yellow',
          'high': 'orange',
          'low': '#82B1FF',
          'info': '#909090',
        },
      }
    },
    methods: {
      getColor(x) {
        return _.get(this.severityColors, x.toLowerCase(), 'accent')
      }
    }
  }
</script>

<style scoped>
.dark-chip-col{
    color:#404040 !important;
}
</style>
